import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('section')

export default function Section({ children, vertical, spaceless, spacelesstop, tight, odd, primary, secondary }) {
  return (
    <section {...bem('', { vertical, spaceless, 'spaceless-top': spacelesstop, tight, odd, primary, secondary })}>
      <div {...bem('content')}>{children}</div>
    </section>
  )
}

Section.propTypes = {
  children: T.any.isRequired,
  tight: T.bool,
  vertical: T.bool,
  odd: T.bool,
  primary: T.bool,
  secondary: T.bool,
  spaceless: T.bool,
  spacelesstop: T.bool,
}
